<template>
    <el-dialog width="620px" title="添加规格" :before-close="handleClickCancel" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="skusAddVisible" append-to-body>
        <div class="details" v-loading="loading">
            <el-table class="custom_table" :data="skusData"  @selection-change="handleSelectionChange" height="500" border row-key="product_name"  ref="multipleTable" >
                <el-table-column align="center" type="selection"  :selectable="disableSelection" reserve-selection width="50"></el-table-column>
                <el-table-column label="规格明细" prop="product_name" width="120">
                    <template slot-scope="{row}">
                        <div style="font-size: 14px;color: rgba(102, 102, 102, 1);line-height: 22px" >
                            <p v-for="item in row.specs">{{item.spec}}:{{item.spec_value}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="产品全称" prop="name" ></el-table-column>
            </el-table>
        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">提交</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {BasicProductSkus } from '@/api'

export default {
    name: 'skus_add',
    props: {
        skusAddVisible: {
            type: Boolean,
            default: false,
        },
        productId: {
            type: Number,
            default: 0,
        },
        goodsId:{
            type: Number,
            default: 0,
        },
        skusSelectedData: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            skusData:[],
            select_skus:[]
        }
    },
    created() {
        this.getBasicProductSkus()
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        getBasicProductSkus(){
            let postData = {
                product_id:this.productId,
                goods_id:this.goodsId,
            }
            this.loading = true
            BasicProductSkus(postData).then(res => {
                if (res.code === 200) {
                    this.skusData = res.data.skus
                    let skusSelectedDataIds = this.skusSelectedData.map(item => item.sku_id)
                    this.skusData.forEach(item => {
                        if(skusSelectedDataIds.includes(item.sku_id)){
                            item.is_online = true
                        }
                    })
                    this.loading = false
                }
            })
        },
        disableSelection(row){
            return !row.is_online
        },
        handleSelectionChange(val){
            val.forEach(item => {
                if (!this.select_skus.some(d => d.product_name === item.product_name)) {
                    this.select_skus.push(item);
                }
            });
            this.select_skus = this.select_skus.filter(d => val.some(item => item.product_name === d.product_name));
        },
        handleClickConfirm(){
            this.$emit('success',this.select_skus)
            this.$emit('update:skusAddVisible', false)
        },
        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:skusAddVisible', false)
        },


    },

}
</script>
<style lang="scss" scoped>
.selectTree{
    width: 100%;
    ::v-deep .el-select-dropdown{
        display: none !important;
    }
}
</style>
